import { html, css } from 'lit-element';
import { BaseElement } from './BaseElement';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { API, EVENT_TYPES } from '../API';
import { DIALOG_TYPE_ERROR, DIALOG_TYPE_INFO } from './ModalDialog';

const _api = Symbol();
const _passwordChangeHandler = Symbol();

class ChangePassword extends BaseElement {
	constructor() {
		super();

		this.library.add(faCheck);

		this[_passwordChangeHandler] = message => {
			this.emit('show-dialog', {
				title: 'Password Change Request',
				message
			});
		};
	}
	static get styles() {
		return [
			...BaseElement.styles,
			css`
				:host {
					
				}
				
				.centered {
					display: flex;
					justify-content: center;
				}
				form {
					display: flex;
					flex-flow: column nowrap;
				}
				label {
					text-align: right;
					margin-bottom: 0.25em;
				}
				a:before {

				}
			`
		];
	}
	get api() {
		return this[_api];
	}
	set api(v) {
		if(v !== null && !(v instanceof API))
			throw new TypeError('api must be an instance of API.');
		this[_api] = v;
	}
	connectedCallback() {
		super.connectedCallback();

		this.emit('get-api', { callback: api => this.api = api });

		this.api.on(EVENT_TYPES.EVENT_TYPE_PASSWORD_CHANGE, this[_passwordChangeHandler]);
	}
	disconnectedCallback() {
		super.disconnectedCallback();

		this.api.off(null, this[_passwordChangeHandler]);

		this.api = null;
	}
	async handleSubmit(e) {
		try {
			e.preventDefault();
			if(!this.api)
				throw new Error('api property not set!');
			
			const { username, password, newPassword, confirm } = Object.fromEntries(new FormData(e.target));
			
			if(!username)
				throw new Error('Please enter your account username.');
			if(!password)
				throw new Error('Please enter your current account password.');
			if(!newPassword)
				throw new Error('Please enter your new account password.');
			if(newPassword !== confirm)
				throw new Error('New account password and confirmation do not match. Please try again.');
			
			e.target.reset();
			const response = await this.api.changePassword(username, password, newPassword);
			this.emit('show-dialog', {
				title: 'Change Password',
				message: response,
				type: DIALOG_TYPE_INFO
			});
			this.emit('password-changed');
		}
		catch(err) {
			this.emit('show-dialog', {
				title: 'Change Password Error',
				message: err.message,
				type: DIALOG_TYPE_ERROR
			});
		}
	}
	render() {
		return html`
			<h4>Change Account Password</h4>
			<p>
				Please complete the following form to change your password.
			</p>
			<div class="centered">
				<form @submit="${e => this.handleSubmit(e)}">
					<label>
						Username: <input type="text" name="username"/>
					</label>
					<label>
						Current Password: <input type="password" name="password"/>
					</label>
					<label>
						New Password: <input type="password" name="newPassword"/>
					</label>
					<label>
						Confirm New Password: <input type="password" name="confirm"/>
					</label>
					<button type="submit">
						<i class="icon fas fa-check"></i>
						Submit
					</button>
				</form>
			</div>
		`;
	}
}

customElements.define('pp-change-password', ChangePassword);